import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { PropTypes } from '@instructure/quiz-interactions';
import LegacyChoiceType from './LegacyChoiceType';
import ChoiceType from './ChoiceType';
import RichFillBlankType from './RichFillBlankType';
import AggregationType from './AggregationType';
import NumericType from './NumericType';
import { MatchingType, OrderingType, CategorizationType } from './MatchingType';
import { ScoreDistributionType } from './ScoreDistributionType';
import { afsFlags, answerSummaryPropType } from '../../common/propTypes';
export var AnswerFrequencySummary = /*#__PURE__*/function (_Component) {
  function AnswerFrequencySummary() {
    var _this;
    _classCallCheck(this, AnswerFrequencySummary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AnswerFrequencySummary, [].concat(args));
    _defineProperty(_this, "afsTableComponentMap", new Map());
    _defineProperty(_this, "addAfsComponentsByFlags", function (afsFlags) {
      if (afsFlags.formulaEnabled) {
        _this.afsTableComponentMap.set('formula', AggregationType);
      }
      if (afsFlags.hotSpotEnabled) {
        _this.afsTableComponentMap.set('hot-spot', AggregationType);
      }
      if (afsFlags.matchingEnabled) {
        _this.afsTableComponentMap.set('matching', MatchingType);
      }
      if (afsFlags.orderingEnabled) {
        _this.afsTableComponentMap.set('ordering', OrderingType);
      }
      if (afsFlags.categorizationEnabled) {
        _this.afsTableComponentMap.set('categorization', CategorizationType);
      }
      if (afsFlags.trueFalseEnabled) {
        _this.afsTableComponentMap.set('true-false', ChoiceType);
      }
      if (afsFlags.choiceEnabled) {
        _this.afsTableComponentMap.set('choice', ChoiceType);
      }
      if (afsFlags.multiAnswerEnabled) {
        _this.afsTableComponentMap.set('multi-answer', ChoiceType);
      }
      if (afsFlags.fillInTheBlankEnabled) {
        _this.afsTableComponentMap.set('rich-fill-blank', RichFillBlankType);
      }
      if (afsFlags.numericEnabled) {
        _this.afsTableComponentMap.set('numeric', NumericType);
      }
      if (afsFlags.essayEnabled) {
        _this.afsTableComponentMap.set('essay', ScoreDistributionType);
      }
      if (afsFlags.fileUploadEnabled) {
        _this.afsTableComponentMap.set('file-upload', ScoreDistributionType);
      }
    });
    _defineProperty(_this, "render", function () {
      var _this$props = _this.props,
        itemId = _this$props.itemId,
        answerSummary = _this$props.answerSummary,
        interactionType = _this$props.interactionType,
        afsFlags = _this$props.afsFlags;
      afsFlags && _this.addAfsComponentsByFlags(afsFlags);
      var AfsTableComponent = _this.afsTableComponentMap.get(interactionType);
      if (!AfsTableComponent || !answerSummary) {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }
      return /*#__PURE__*/React.createElement(AfsTableComponent, {
        itemId: itemId,
        answerSummary: answerSummary
      });
    });
    _this.afsTableComponentMap.set('true-false', LegacyChoiceType);
    _this.afsTableComponentMap.set('choice', LegacyChoiceType);
    _this.afsTableComponentMap.set('multi-answer', LegacyChoiceType);
    return _this;
  }
  _inherits(AnswerFrequencySummary, _Component);
  return _createClass(AnswerFrequencySummary);
}(Component);
_defineProperty(AnswerFrequencySummary, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: answerSummaryPropType.isRequired,
  interactionType: PropTypes.string.isRequired,
  afsFlags: afsFlags
}.isRequired);